import { __decorate } from "tslib";
import CustomSwitch from '@/components/CustomSwitch.vue';
import TimeDeltaPicker from '@/components/TimeDeltaPicker.vue';
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import TimeTemplateSelectComponent from './TimeTemplateSelect.vue';
let AppointmentNotification = class AppointmentNotification extends Vue {
    value;
    enableSendAtCreate;
    hideSchedule;
    hideSelect;
    startAt;
    data = null;
    get calculatedDeltas() {
        if (!this.data)
            return [];
        return this.data.deltas.map((delta) => {
            return {
                delta: delta.delta,
                calculated: this.$moment(this.startAt).subtract(delta.delta, 'seconds').format()
            };
        });
    }
    emitInput(val) {
        return val;
    }
    valueWatcher(newValue) {
        this.data = newValue;
    }
    dataWatcher(newValue) {
        this.emitInput(newValue);
    }
    isInPast(delta) {
        return this.$moment(this.startAt).subtract(delta, 'seconds').isBefore();
    }
    addTimeTemplate() {
        if (!this.data)
            return;
        this.data.deltas.push({ delta: 3600 });
    }
    removeTimeTemplate(index) {
        if (!this.data)
            return;
        this.data.deltas.splice(index, 1);
    }
};
__decorate([
    Prop({ required: true })
], AppointmentNotification.prototype, "value", void 0);
__decorate([
    Prop({ type: Boolean, default: true })
], AppointmentNotification.prototype, "enableSendAtCreate", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], AppointmentNotification.prototype, "hideSchedule", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], AppointmentNotification.prototype, "hideSelect", void 0);
__decorate([
    Prop({ type: String })
], AppointmentNotification.prototype, "startAt", void 0);
__decorate([
    Emit('input')
], AppointmentNotification.prototype, "emitInput", null);
__decorate([
    Watch('value')
], AppointmentNotification.prototype, "valueWatcher", null);
__decorate([
    Watch('data')
], AppointmentNotification.prototype, "dataWatcher", null);
AppointmentNotification = __decorate([
    Component({
        components: {
            TimeDeltaPicker,
            CustomSwitch,
            TimeTemplateSelectComponent,
        }
    })
], AppointmentNotification);
export default AppointmentNotification;
